import { render, staticRenderFns } from "./iamVoteQuestiong.vue?vue&type=template&id=9405e65a&scoped=true&"
import script from "./iamVoteQuestiong.vue?vue&type=script&lang=js&"
export * from "./iamVoteQuestiong.vue?vue&type=script&lang=js&"
import style0 from "./iamVoteQuestiong.vue?vue&type=style&index=0&id=9405e65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9405e65a",
  null
  
)

export default component.exports